import { Hitch } from 'services/apps/hitches';
import { Categories, CategoryType } from 'services/apps/categories';
import usecases, { BaseUseCase, UseCase } from 'services/apps/usecases';

type FindMatchingUseCases = {
  firstApp?: Hitch;
  secondApp?: Hitch;
};

export default function findMatchingUseCases({
  firstApp,
  secondApp,
}: FindMatchingUseCases): BaseUseCase[] {
  if (!firstApp) {
    return [];
  }

  const firstAppUseCases = ([] as BaseUseCase[]).concat(
    ...firstApp.category.map((cat) => Categories[cat].usecases)
  );

  if (!secondApp) {
    return firstAppUseCases;
  }
  return usecases.filter((uc: UseCase) => {
    function hasMatchWithApps(categories: CategoryType[]): boolean[] {
      let firstAppOk = false;
      let secondAppOk = false;

      categories.forEach((categoryId) => {
        const firstAppMatch = hasMatchingCategory(categoryId, firstApp as Hitch);
        if (firstAppMatch) {
          firstAppOk = true;
        }

        const secondAppMatch = hasMatchingCategory(categoryId, secondApp as Hitch);
        if (secondAppMatch) {
          secondAppOk = true;
        }
        return firstAppMatch || secondAppMatch;
      });

      return [firstAppOk, secondAppOk];
    }

    const [firstAppMatch, secondAppMatch] = hasMatchWithApps(uc.categories);
    const [firstAppLinkedMatch, secondAppLinkedMatch] = hasMatchWithApps(uc.linkedCategories);

    if ((firstAppMatch && secondAppLinkedMatch) || (firstAppLinkedMatch && secondAppMatch)) {
      return true;
    } else {
      return false;
    }
  });
}

export function getUseCase(useCaseId: string): BaseUseCase | undefined {
  return usecases.find((uc: UseCase) => uc.id === useCaseId);
}

function hasMatchingCategory(categoryId: string, hitch: Hitch) {
  return hitch.category.findIndex((hitchCategoryId) => hitchCategoryId === categoryId) !== -1;
}
